<template>
  <div>
    <template v-if="shipment">
      <v-card class="elevation-12">
        <v-expansion-panels v-model="panels" multiple focusable accordion>
          <v-expansion-panel>
            <v-expansion-panel-header> Новая счёт-фактура</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" sm="6" lg="3" class="pa-2">
                  <v-text-field v-model="form.number" dense label="Номер счёт-фактуры" :hide-details="true" :error="$v.form.number.$error || isNumberUniqueError" outlined/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="shipment.date" dense label="Дата счёт-фактуры" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                </v-col>

                <v-col cols="12" lg="6" offset-lg="1" class="pa-2">
                  <v-text-field label="Пукнт приема" v-model="shipment.deliveryAddress" dense outlined :hide-details="true" disabled/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" lg="3" class="pa-2">
                  <v-text-field v-model="shipment.contractNumber" dense label="Номер договора" :hide-details="true" outlined :disabled="true"/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="shipment.contractDate" dense label="Дата договора" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" lg="3" class="pa-2">
                  <v-text-field v-model="shipment.number" dense label="Номер накладной" :hide-details="true" outlined :disabled="true"/>
                </v-col>
                <v-col cols="12" sm="6" lg="2" class="pa-2">
                  <DateInput v-model="shipment.date" dense label="Дата накладной" :hide-details="true" :disabled="true" outlined :clearable="false" :prepend-icon="false" :append-icon="false"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Реквизиты сторон</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col lg="6" cols="12">
                  <h3 class="mb-4">Заказчик</h3>
                  <v-text-field label="Наименование" v-model="shipment.customerName" dense outlined :hide-details="true" disabled class="my-2"/>
                  <v-text-field label="Инн" v-model="shipment.customerInn" dense outlined :hide-details="true" disabled class="my-2"/>

                  <v-text-field label="Адрес" v-model="form.customer.address" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Расчётный счёт" v-model="form.customer.bankAccount" :error="$v.form.customer.bankAccount.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="МФО" v-model="form.customer.bankMfo" :error="$v.form.customer.bankMfo.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Название банка" v-model="form.customer.bankName" :error="$v.form.customer.bankName.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="ОКЭД" v-model="form.customer.oked" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Код НДС регистрации" v-model="form.customer.vatCode" dense outlined :hide-details="true" class="my-2"/>
                </v-col>
                <v-col lg="6" cols="12">
                  <h3 class="mb-4">Поставщик</h3>
                  <v-text-field label="Наименование" v-model="shipment.executorName" dense outlined :hide-details="true" disabled class="my-2"/>
                  <v-text-field label="Инн" v-model="shipment.executorInn" dense outlined :hide-details="true" disabled class="my-2"/>

                  <v-text-field label="Адрес" v-model="form.executor.address" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Расчётный счёт" v-model="form.executor.bankAccount" :error="$v.form.executor.bankAccount.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="МФО" v-model="form.executor.bankMfo" :error="$v.form.executor.bankMfo.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Название банка" v-model="form.executor.bankName" :error="$v.form.executor.bankName.$error" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="ОКЭД" v-model="form.executor.oked" dense outlined :hide-details="true" class="my-2"/>
                  <v-text-field label="Код НДС регистрации" v-model="form.executor.vatCode" dense outlined :hide-details="true" class="my-2"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Товары и услуги</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-actions>
                  <v-spacer/>
                  <v-dialog v-model="lgotaDialog" max-width="768">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn text v-on="on" v-bind="attrs" color="primary" outlined small>
                        Выбрать льготу для всех позиций
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="headline grey lighten-2"> Выбор льготы</v-card-title>
                      <v-card-text>
                        <SelectInvoiceItemLgota v-model="lgota"/>
                      </v-card-text>
                      <v-divider/>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" text @click="lgotaDialog = false"> Закрыть</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <SelectInvoiceItemCatalog :product-catalogs="productCatalogs" :disable-package="true" :selected-catalog="catalog" title="Выбрать МХИК для всех позиций" @selected="(catalog, catalogPackage, lgota) => onMxikSelected(catalog, catalogPackage, lgota)"/>
                </v-card-actions>
              </v-card>

              <v-divider/>

              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center py-0 pa-1" style="width: 40px;">№</th>
                    <th class="text-center py-0 pa-1" style="width: 70px">ИКПУ-код</th>
                    <th class="text-left py-0 pa-1">Товар</th>
                    <th class="text-center py-0 pa-1" style="width: 115px;">Льгота</th>
                    <th class="text-center py-0 pa-1" style="width: 115px;">ИД позиции поставки</th>
                    <th class="text-center py-0 pa-1" style="width: 100px;">Штрих-код</th>
                    <th class="text-center py-0 pa-1" style="width: 40px;">Ед.изм</th>
                    <th class="text-right py-0 pa-1" style="width: 60px;">Количество</th>
                    <th class="text-right py-0 pa-1" style="width: 120px;">Цена за единицу</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость</th>
                    <th class="text-center py-0 pa-1" style="width: 50px;">Ставка ндс</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Сумма ндс</th>
                    <th class="text-right py-0 pa-1" style="width: 125px;">Стоимость с учётом НДС</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in form.items" :key="item.id">
                    <td class="text-center py-0 pa-1">{{ index + 1 }}</td>
                    <td class="text-center py-0 pa-1">
                      <SelectMxikProduct :product-catalogs="productCatalogs" :disable-package="true" :error="$v.form.items.$each[index].catalog.$error" :selected-catalog="item.catalog" :default-catalog="item.defaultCatalogCode" :default-package="item.defaultCatalogPackageCode" @selected="(catalog, catalogPackage) => onItemMxikSelected(item, catalog, catalogPackage)"/>
                    </td>
                    <td class="text-left py-0 pa-1">{{ item.product }}</td>
                    <td class="text-left py-0 pa-1">
                      <v-dialog v-model="item.lgotaDialog" max-width="768">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn text :color="$v.form.items.$each[index].lgota.$error ? 'error' : 'primary'" v-on="on"
                                 v-bind="attrs" small outlined>
                            {{ item.lgota ? item.lgota : 'Выбрать' }}
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline grey lighten-2"> Выбор льготы</v-card-title>
                          <v-card-text>
                            <CatalogCodeLgota v-model="item.lgota" :catalog-code="item.catalog"/>
                          </v-card-text>
                          <v-divider/>
                          <v-card-actions>
                            <v-spacer/>
                            <v-btn color="primary" text @click="item.lgotaDialog = false"> Закрыть</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.orderItem.customerShipmentItemId">
                        {{ item.orderItem.customerShipmentItemId }}
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.customerCode">
                        {{ item.customerCode }}
                      </template>
                      <template v-else>
                        Нет
                      </template>
                    </td>
                    <td class="text-center py-0 pa-1">
                      <template v-if="item.catalogPackage">
                        {{ item.catalogPackage.nameRu }}
                      </template>
                      <template v-else>
                        {{ item.measurement }}
                      </template>
                    </td>
                    <td class="text-right py-0 pa-1">
                      {{ item.quantity | decimalNoTrim }}
                    </td>
                    <td class="text-right py-0 pa-1">{{ item.price | decimalNoTrim }}</td>
                    <td class="text-right py-0 pa-1">{{ item.total | decimalMinorCeilTwoDigit }}</td>
                    <td class="text-center py-0 pa-1">{{ item.ndsRate | decimalNoTrim }}</td>
                    <td class="text-right py-0 pa-1">
                      {{ item.ndsValue | decimalMinorCeilTwoDigit }}
                    </td>
                    <td class="text-right py-0 pa-1">
                      {{ item.totalWithNds | decimalMinorCeilTwoDigit }}
                    </td>
                  </tr>
                  <tr class="blue-grey lighten-4">
                    <td></td>
                    <td class="text-left px-1"><b>Итого</b></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.total |  decimalMinorCeilTwoDigit }}</b></td>
                    <td class="text-right"></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.ndsValue |  decimalMinorCeilTwoDigit }}</b></td>
                    <td class="text-right py-0 pa-1"><b>{{ totals.totalWithNds | decimalMinorCeilTwoDigit }}</b></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Подписи сторон</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-combobox v-model="form.executorDirector" dense label="Руководитель предприятия" :hide-details="true" :error="$v.form.executorDirector.$error" :items="storageSignaturesOfThePartiesInfo.executorDirectors" outlined>
                    <template v-slot:item="{item}">
                      <span style="flex-grow:1">{{ item }}</span>
                      <v-btn icon color="red" @click="()=>removeDuplicateExecutorDirector(item)">
                        <v-icon size="18" right>fa-trash</v-icon>
                      </v-btn>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-combobox v-model="form.customerProxyName" dense label="ФИО получателя" :hide-details="true" :error="$v.form.customerProxyName.$error" :items="storageSignaturesOfThePartiesInfo.customerProxyNames" outlined>
                    <template v-slot:item="{item}">
                      <span style="flex-grow:1">{{ item }}</span>
                      <v-btn icon color="red" @click="()=>removeDuplicateCustomerProxyName(item)">
                        <v-icon size="18" right>fa-trash</v-icon>
                      </v-btn>
                    </template>
                  </v-combobox>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-combobox v-model="form.executorAccountant" dense label="Главный бухгалтер" :hide-details="true" :error="$v.form.executorAccountant.$error" :items="storageSignaturesOfThePartiesInfo.executorDirectors" outlined>
                    <template v-slot:item="{item}">
                      <span style="flex-grow:1">{{ item }}</span>
                      <v-btn icon color="red" @click="()=>removeDuplicateExecutorAccountant(item)">
                        <v-icon size="18" right>fa-trash</v-icon>
                      </v-btn>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-text-field v-model="form.customerProxyNumber" dense label="Номер доверенности" :hide-details="true" :error="$v.form.customerProxyNumber.$error" outlined/>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="12" lg="6" class="pa-2">
                  <v-combobox v-model="form.executorReleaser" dense label="Товар отпустил" :hide-details="true" :error="$v.form.executorReleaser.$error" :items="storageSignaturesOfThePartiesInfo.executorReleasers" outlined>
                    <template v-slot:item="{item}">
                      <span style="flex-grow:1">{{ item }}</span>
                      <v-btn icon color="red" @click="()=>removeDuplicateExecutorReleaser(item)">
                        <v-icon size="18" right>fa-trash</v-icon>
                      </v-btn>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col cols="12" lg="6" class="pa-2">
                  <DateInput v-model="form.customerProxyDate" dense label="Дата доверенности" :hide-details="true" outlined :append-icon="true" :prepend-icon="false"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="onSaveButtonClicked"> Создать</v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="saveFailedDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 error--text"> Ошибка при обработке запроса на сервере</v-card-title>
          <v-card-text> {{ saveFailedDialogText }}</v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" text @click="saveFailedDialog = false">Закрыть</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <h3>Идет загрузка...</h3>
    </template>
  </div>
</template>

<script>
import ShipmentService from "@/services/shipment.service";
import BankService from "@/services/bank.service";
import CompanyService from "@/services/company.service"
import * as LayoutActions from "@/store/modules/layout/actions";
import * as ShipmentStatuses from "@/enum/ShipmentStatus";
import Moment from "moment";
import _ from "underscore";
import mappers from "@/helpers/mappers";
import DateInput from "@/components/Input/DateInput";
import {validationMixin} from "vuelidate";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import InvoiceService from "@/services/invoice.service";
import SelectMxikProduct from "@/components/Select/SelectMxikProduct";
import SelectInvoiceItemCatalog from "@/components/Select/SelectInvoiceItemCatalog";
import SelectInvoiceItemLgota from "@/components/Select/SelectInvoiceItemLgota";
import CatalogCodeLgota from "@/components/Select/SelectInvoiceCatalogLgota"
import {MOMENT_API_DATE_FORMAT} from "@/settings";

const StorageMxikCatalogPackageKey = "mxik-catalog-package"
const storageSignaturesOfThePartiesKey = "storageSignaturesOfTheParties"

export default {
  name: "AddInvoiceView",
  mixins: [validationMixin],
  components: {SelectInvoiceItemLgota, SelectMxikProduct, DateInput, CatalogCodeLgota, SelectInvoiceItemCatalog},
  validations: {
    form: {
      number: {
        required,
        maxLength: maxLength(100),
      },
      executorDirector: {
        required,
        maxLength: maxLength(100)
      },
      executorAccountant: {
        required,
        maxLength: maxLength(100)
      },
      executorReleaser: {
        required,
        maxLength: maxLength(100)
      },
      customerProxyNumber: {
        maxLength: maxLength(100)
      },
      customerProxyName: {
        maxLength: maxLength(100)
      },
      executor: {
        address: {
          maxLength: maxLength(500)
        },
        bankAccount: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(20),
          format: numeric
        },
        bankName: {
          required,
          maxLength: maxLength(500)
        },
        bankMfo: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        oked: {
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        vatCode: {
          format: numeric
        }
      },
      customer: {
        address: {
          maxLength: maxLength(500)
        },
        bankAccount: {
          required,
          maxLength: maxLength(20),
          minLength: minLength(20),
          format: numeric
        },
        bankName: {
          required,
          maxLength: maxLength(500)
        },
        bankMfo: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        oked: {
          minLength: minLength(5),
          maxLength: maxLength(5),
          format: numeric
        },
        vatCode: {
          format: numeric
        }
      },
      items: {
        required,
        $each: {
          lgota: {
            required(value, model) {
              if (this.form.executor.vatCode && model.ndsRate === 0)
                return !!value
              return true
            }
          },
          catalog: {
            required
          },
          barcode: {
            maxLength: maxLength(50)
          },
          measurement: {
            required
          }
        }
      }
    }
  },
  data() {
    return {
      shipment: null,
      previousInvoice: null,
      productCatalogs: [],
      loading: false,
      panels: [0, 1, 2, 3],
      totals: {
        total: 0,
        ndsValue: 0,
        totalWithNds: 0
      },
      catalog: null,
      catalogPackage: null,
      lgota: null,
      lgotaDialog: false,

      saveFailedDialogText: '',
      saveFailedDialog: false,

      isNumberUniqueError: false,
      form: {
        number: '',
        executorDirector: '',
        executorAccountant: '',
        executorReleaser: '',

        customerProxyName: '',
        customerProxyNumber: '',
        customerProxyDate: null,

        executor: {
          address: '',
          bankAccount: '',
          bankName: '',
          bankMfo: '',
          oked: '',
          vatCode: ''
        },
        customer: {
          address: '',
          bankAccount: '',
          bankName: '',
          bankMfo: '',
          oked: '',
          vatCode: ''
        },

        items: [],

      },
      storageSignaturesOfThePartiesInfo: localStorage.getItem(storageSignaturesOfThePartiesKey) ? JSON.parse(localStorage.getItem(storageSignaturesOfThePartiesKey)) : {
        executorDirectors: [],
        customerProxyNames: [],
        executorAccountants: [],
        executorReleasers: []
      }
    }
  },
  methods: {
    loadShipment() {
      this.$store.dispatch(LayoutActions.LAYOUT_LOADING_START)
      this.loading = true
      ShipmentService.getInfo(this.$route.params.id)
          .then(response => {
            this.shipment = {
              id: response.data.Id,
              status: response.data.Status,
              statusText: ShipmentStatuses.GetStatusText(response.data.Status),

              number: response.data.Number,
              date: Moment(response.data.Date),

              contractNumber: response.data.ContractNumber,
              contractDate: Moment(response.data.ContractDate),

              customerInn: response.data.ConsigneeInn,
              customerName: response.data.ConsigneeName,

              executorInn: response.data.CustomerInn,
              executorName: response.data.CustomerName,

              deliveryAddress: response.data.DeliveryAddress,

              total: response.data.Total,
              totalInWords: response.data.TotalInWords,

              items: _.map(response.data.Items, item => {
                return {
                  id: item.Id,
                  product: item.Product,
                  customerCode: item.CustomerCode,
                  catalogCode: item.CatalogCode,
                  catalogName: item.CatalogName,
                  measurement: item.Measurement,
                  quantity: item.Quantity,
                  price: item.Price,
                  total: item.Total,
                  ndsRate: item.NdsRate,
                  ndsValue: item.NdsValue,
                  totalWithNds: item.TotalWithNds,
                  orderItem: mappers.mapOrderItem(item.OrderItem)
                }
              })
            }

            this.onShipmentLoaded()
          })
          .catch(e => {
            window.console.log(e)
            this.$router.go(-1)
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LayoutActions.LAYOUT_LOADING_STOP)
          })
    },
    loadPreviousInvoice() {
      InvoiceService.getExecutorLastInfo()
          .then(response => {
            this.previousInvoice = {
              executorDirector: response.data.ExecutorDirector,
              executorAccountant: response.data.ExecutorAcccountant,
              executorReleaser: response.data.ExecutorReleaser,
              customerProxyName: response.data.CustomerProxyName,
              customerProxyNumber: response.data.CustomerProxyNumber,
              customerProxyDate: response.data.CustomerProxyDate ? Moment(response.data.CustomerProxyDate) : null,
            }

            //Set if executor bank detail is empty
            if(response.data.ExecutorDetail&&!this.form.executor.address)
              this.form.executor.address =  response.data.ExecutorDetail.Address

            if(response.data.ExecutorDetail&&!this.form.executor.bankAccount)
              this.form.executor.bankAccount =  response.data.ExecutorDetail.BankAccountNumber

            if(response.data.ExecutorDetail&&!this.form.executor.bankName)
              this.form.executor.bankName =  response.data.ExecutorDetail.BankName

            if(response.data.ExecutorDetail&&!this.form.executor.bankMfo)
              this.form.executor.bankMfo =  response.data.ExecutorDetail.BankMfo

            if(response.data.ExecutorDetail&&!this.form.executor.oked)
              this.form.executor.oked =  response.data.ExecutorDetail.Oked

            if(response.data.ExecutorDetail&&!this.form.executor.vatCode)
              this.form.executor.vatCode =  response.data.ExecutorDetail.NdsRegistrationCode

            //Set if customer bank detail is empty
            if(response.data.CustomerDetail&&!this.form.customer.address)
              this.form.customer.address =  response.data.CustomerDetail.Address

            if(response.data.CustomerDetail&&!this.form.customer.bankAccount)
              this.form.customer.bankAccount =  response.data.CustomerDetail.BankAccountNumber

            if(response.data.CustomerDetail&&!this.form.customer.bankName)
              this.form.customer.bankName =  response.data.CustomerDetail.BankName

            if(response.data.CustomerDetail&&!this.form.customer.bankMfo)
              this.form.customer.bankMfo =  response.data.CustomerDetail.BankMfo

            if(response.data.CustomerDetail&&!this.form.customer.oked)
              this.form.customer.oked =  response.data.CustomerDetail.Oked

            if(response.data.CustomerDetail&&!this.form.customer.vatCode)
              this.form.customer.NdsRegistrationCode =  response.data.CustomerDetail.vatCode
            
            this.onPreviousInvoiceLoaded()
          })
    },
    loadCompanyDetails(inn, member) {
      CompanyService.getSoliqDetails(inn)
          .then(response => {

            if(response.data.Address && !member.address)
              member.address = response.data.Address

            if(response.data.Account && !member.bankAccount)
              member.bankAccount = response.data.Account

            if(response.data.Mfo && !member.bankMfo)
              member.bankMfo = response.data.Mfo

            if(response.data.Oked && !member.oked)
              member.oked = response.data.Oked

            if (member.bankMfo) {
              BankService.get(member.bankMfo)
                  .then(response => {
                    member.bankName = response.data.Name || ''
                  })
            }
          })
      CompanyService.getVatCode(inn)
          .then(response => {
            if (response.data)
              member.vatCode = response.data || ''
          })
    },
    loadProductCatalogs() {
      CompanyService.getCompanyCatalogCodesInfo()
          .then(response => {
            this.productCatalogs = response.data
          })
    },

    onShipmentLoaded() {
      let mxikCatalogPackages = {}

      try {
        const storageValue = localStorage.getItem(StorageMxikCatalogPackageKey)
        if (storageValue)
          mxikCatalogPackages = JSON.parse(storageValue)

        _.each(this.form.items, item => {
          mxikCatalogPackages[item.product] = {
            catalogCode: item.catalog.classCode,
            catalogPackageCode: item.catalogPackage ? item.catalogPackage.code : null
          }
        })
      } catch (e) {
        window.console.log(e)
      }

      this.form.number = this.shipment.number
      this.form.items = this.shipment.items.filter(item => {
        return item.quantity !== 0
      }).map(item => {
        const mxikCatalogPackage = mxikCatalogPackages[item.product] || null

        return {
          id: item.id,
          product: item.product,
          customerCode: item.customerCode,
          catalogCode: item.catalogCode,
          catalogName: item.catalogName,
          measurement: item.measurement,
          quantity: item.quantity,
          price: item.price,
          total: item.total,
          ndsRate: item.ndsRate,
          ndsValue: item.ndsValue,
          totalWithNds: item.totalWithNds,
          orderItem: item.orderItem,
          measurement_code: null,
          catalog: null,
          catalogPackage: null,
          lgota: null,
          lgotaDialog: false,
          defaultCatalogCode: mxikCatalogPackage ? mxikCatalogPackage.catalogCode : null,
          defaultCatalogPackageCode: mxikCatalogPackage ? mxikCatalogPackage.catalogPackageCode : null
        }
      })

      this.totals.total = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.total
      }, 0)
      this.totals.ndsValue = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.ndsValue
      }, 0)
      this.totals.totalWithNds = _.reduce(this.shipment.items, (memo, item) => {
        return memo + item.totalWithNds
      }, 0)

      this.loadCompanyDetails(this.shipment.customerInn, this.form.customer)
      this.loadCompanyDetails(this.shipment.executorInn, this.form.executor)

      this.loadProductCatalogs()
    },
    onPreviousInvoiceLoaded() {
      this.form.executorDirector = this.previousInvoice.executorDirector || ''
      this.form.executorAccountant = this.previousInvoice.executorAccountant || ''
      this.form.executorReleaser = this.previousInvoice.executorReleaser || ''
      this.form.customerProxyName = this.previousInvoice.customerProxyName || ''
      this.form.customerProxyNumber = this.previousInvoice.customerProxyNumber || ''
      this.form.customerProxyDate = this.previousInvoice.customerProxyDate
    },
    onItemMxikSelected(item, catalog, catalogPackage) {
      item.catalog = catalog
      item.catalogPackage = catalogPackage
    },
    onMxikSelected(catalog, catalogPackage, lgota) {
      _.each(this.form.items, item => {
        item.catalog = catalog || null
        item.lgota = lgota ? lgota : item.lgota
        item.catalogPackage = catalogPackage || null
      })
    },
    onSaveButtonClicked() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const data = {
          ShipmentWaybillId: this.shipment.id,
          Number: this.form.number,
          Date: this.shipment.date.format(MOMENT_API_DATE_FORMAT),
          CustomerDetail: {
            Inn: this.shipment.customerInn,
            Name: this.shipment.customerName,
            Address: this.form.customer.address,
            BankAccountNumber: this.form.customer.bankAccount,
            BankName: this.form.customer.bankName,
            BankMfo: this.form.customer.bankMfo,
            Oked: this.form.customer.oked,
            NdsRegistrationCode: this.form.customer.vatCode ? this.form.customer.vatCode : null
          },
          ExecutorDetail: {
            Inn: this.shipment.executorInn,
            Name: this.shipment.executorName,
            Address: this.form.executor.address,
            BankAccountNumber: this.form.executor.bankAccount,
            BankName: this.form.executor.bankName,
            BankMfo: this.form.executor.bankMfo,
            Oked: this.form.executor.oked,
            NdsRegistrationCode: this.form.executor.vatCode ? this.form.executor.vatCode : null
          },
          Total: this.shipment.total,
          TotalInWords: this.shipment.totalInWords,
          ExecutorDirector: this.form.executorDirector,
          ExecutorAcccountant: this.form.executorAccountant,
          ExecutorReleaser: this.form.executorReleaser,
          CustomerProxyNumber: this.form.customerProxyNumber,
          CustomerProxyDate: this.form.customerProxyDate ? this.form.customerProxyDate.format(MOMENT_API_DATE_FORMAT) : null,
          CustomerProxyName: this.form.customerProxyName,

          Items: _.map(this.form.items, i => {
            return {
              ShipmentItemId: i.id,
              Product: i.product,
              Measurement: i.catalogPackage ? i.catalogPackage.nameRu : i.measurement,
              MeasurementCode: i.catalogPackage ? i.catalogPackage.code : null,
              Quantity: +i.quantity,
              Price: +i.price,
              Total: +i.total,
              ExciseTaxRate: i.exciseTaxRate,
              ExciseTaxValue: i.exciseTaxValue,
              NdsRate: +i.ndsRate,
              NdsValue: +i.ndsValue,
              TotalWithNds: +i.totalWithNds,
              CatalogCode: i.catalog.classCode,
              CatalogName: i.catalog.name,
              Barcode: i.barcode,
              LgotaId: i.lgota
            }
          })
        }

        this.$store.dispatch(LayoutActions.LAYOUT_LOADING_START)
        this.loading = true
        this.isNumberUniqueError = false
        InvoiceService.register(data)
            .then(response => {
              try {
                let mxikCatalogPackages = {}
                const storageValue = localStorage.getItem(StorageMxikCatalogPackageKey)
                if (storageValue)
                  mxikCatalogPackages = JSON.parse(storageValue)

                _.each(this.form.items, item => {
                  mxikCatalogPackages[item.product] = {
                    catalogCode: item.catalog.classCode,
                    catalogPackageCode: item.catalogPackage ? item.catalogPackage.code : null
                  }
                })

                localStorage.setItem(StorageMxikCatalogPackageKey, JSON.stringify(mxikCatalogPackages))
              } catch (e) {
                window.console.log(e)
              }

              this.$router.push({name: 'invoice-page', params: {id: response.data.Id}});
            })
            .catch(exception => {
              window.console.log(exception)
              if (exception.response && exception.response.data && exception.response.data.Message && exception.response.data.Message.Message) {
                this.saveFailedDialogText = exception.response.data.Message.Message
                this.saveFailedDialog = true

                this.isNumberUniqueError = exception.response.data.Message.Code === 102
              }
            })
            .finally(() => {
              this.savesSorageSignaturesOfThePartiesInfo()
              this.$store.dispatch(LayoutActions.LAYOUT_LOADING_STOP)
              this.loading = false
            })
      }
    },

    removeDuplicateExecutorDirector(item) {
      const executorDirector = this.storageSignaturesOfThePartiesInfo.executorDirectors.find(el => el === item)
      this.storageSignaturesOfThePartiesInfo.executorDirectors.splice(executorDirector, 1)
    },

    removeDuplicateCustomerProxyName(item) {
      const customerProxyName = this.storageSignaturesOfThePartiesInfo.customerProxyNames.find(el => el === item)
      this.storageSignaturesOfThePartiesInfo.customerProxyNames.splice(customerProxyName, 1)
    },

    removeDuplicateExecutorAccountant(item) {
      const executorAccountant = this.storageSignaturesOfThePartiesInfo.executorAccountants.find(el => el === item)
      this.storageSignaturesOfThePartiesInfo.executorAccountants.splice(executorAccountant, 1)
    },

    removeDuplicateExecutorReleaser(item) {
      const executorReleaser = this.storageSignaturesOfThePartiesInfo.executorReleasers.find(el => el === item)
      this.storageSignaturesOfThePartiesInfo.executorReleasers.splice(executorReleaser, 1)
    },

    savesSorageSignaturesOfThePartiesInfo() {
      if (this.storageSignaturesOfThePartiesInfo.executorDirectors.indexOf(this.form.executorDirector) === -1)
        this.storageSignaturesOfThePartiesInfo.executorDirectors.push(this.form.executorDirector)

      if (this.storageSignaturesOfThePartiesInfo.customerProxyNames.indexOf(this.form.customerProxyName) === -1)
        this.storageSignaturesOfThePartiesInfo.customerProxyNames.push(this.form.customerProxyName)

      if (this.storageSignaturesOfThePartiesInfo.executorAccountants.indexOf(this.form.executorAccountant) === -1)
        this.storageSignaturesOfThePartiesInfo.executorAccountants.push(this.form.executorAccountant)

      if (this.storageSignaturesOfThePartiesInfo.executorReleasers.indexOf(this.form.executorReleaser) === -1)
        this.storageSignaturesOfThePartiesInfo.executorReleasers.push(this.form.executorReleaser)

      localStorage.setItem(storageSignaturesOfThePartiesKey, JSON.stringify(this.storageSignaturesOfThePartiesInfo))
    }
  },
  created() {
    this.loadShipment()
    this.loadPreviousInvoice()
  },
  watch: {
    lgota() {
      if (this.lgota)
        _.each(this.form.items, item => {
          item.lgota = this.lgota
        })
    }
  }
}
</script>